<template>
  <div class="ruejai-club-package-selector" :class="classList">
    <searchable-ruejai-club-package-list
      v-if="showSearchList"
      class="search-list"
      :query="query"
      @queryChange="handleQueryChange"
      :isLoading="isLoading"
      :value="selectablePackages"
      @select="handleSelectPackage"
    ></searchable-ruejai-club-package-list>
    <selected-ruejai-club-package-list
      :disabled="disabled"
      class="selected-list"
      :value="value"
      @remove="handleRemovePackage"
      @removeAll="handleRemoveAllPackage"
    ></selected-ruejai-club-package-list>
  </div>
</template>

<script>
import differenceWith from "ramda/src/differenceWith";
import { Input } from "element-ui";
import RuejaiClubPackageSelectorOption from "./RuejaiClubPackageSelectorOption";
import SelectedRuejaiClubPackageList from "./SelectedRuejaiClubPackageList";
import SearchableRuejaiClubPackageList from "./SearchableRuejaiClubPackageList";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { debounce } from "@/lib/util";
import { isNil } from "ramda";

export default {
  components: {
    RuejaiClubPackageSelectorOption,
    "el-input": Input,
    SelectedRuejaiClubPackageList,
    SearchableRuejaiClubPackageList,
    ScButton
  },
  props: ["initialPackages", "value", "disabled"],
  data() {
    return {
      query: "",
      allPackages: [],
      isLoading: false
    };
  },
  computed: {
    selectablePackages() {
      return differenceWith(this.comparePackage, this.allPackages, this.value);
    },
    disabledRemoveButton() {
      return this.value.length === 0;
    },
    showSearchList() {
      return !this.disabled;
    },
    classList() {
      return { disabled: this.disabled };
    }
  },
  watch: {
    query(oldVal, newVal) {
      this.watchQuery();
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupPackages();
    },
    async setupPackages() {
      const params = this.query ? { name: this.query } : {};
      const packages = await this.fetchPackages(params);

      this.allPackages = packages.map(item => {
        const {
          id,
          name,
          detail,
          type,
          thumbnail_url: thumbnailUrl
        } = item;

        return {
          id,
          name,
          detail,
          type,
          thumbnailUrl
        };
      });
    },
    async fetchPackages(params = {}) {
      if (this.initialPackages) {
        return this.initialPackages;
      }

      this.isLoading = true;
      const response = await baanRueJaiClient.admin.ruejaiClub.packages.list(
        params
      );

      this.isLoading = false;
      return response.data.result.items;
    },
    handleSelectPackage(item) {
      this.updateInput([...this.value, item]);
    },
    handleRemovePackage(item) {
      this.updateInput(this.value.filter(({ id }) => item.id !== id));
    },
    handleRemoveAllPackage() {
      if (!confirm("คุณต้องการลบรายการ package ใช่หรือไม่")) {
        return;
      }

      this.updateInput([]);
    },
    updateInput(value) {
      this.$emit("input", value);
    },
    comparePackage(item, item2) {
      return item.id === item2.id;
    },
    handleQueryChange(value) {
      this.query = value;
    },
    watchQuery: debounce(function() {
      this.setupPackages();
    }, 1.5)
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.ruejai-club-package-selector {
  display: grid;
  grid-template-columns: 1fr 1fr;

  > .search-list {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  > .selected-list {
    border-left-width: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.ruejai-club-package-selector.disabled {
  display: block;

  > .selected-list {
    border-left-width: 1px;
    border-radius: $border-radius;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/RuejaiClubPackageSelector/RuejaiClubPackageSelector.vue